import {
  stickWithRigthAspectRatio
} from "./style";

export const settings = window.settings;
export const xlength = settings.photo_info.rows - 1;
export const ylength = settings.photo_info.cols - 1;
export const imgWidth = settings.photo_info.width;
export const imgHeight = settings.photo_info.height;
export const fullRotationTime = settings.animation_settings.rotate_period;
export const mouseSpeed = settings.animation_settings.mouse_speed;
export const isSmothZoom = settings.animation_settings.zoom_type === "smooth";
export const app = document.querySelector(".app");
export let image = document.querySelector("#image");
export let interval;
export let autoRotationInterval;
export let currentImage;
export let zoomMode = false;
export let viewer;
let isLoading = false;
let sourceArray = [];
let hotspotArray = [];

export const setSourceArray = (array) => {
  sourceArray = array;
};

export const setHotspotArray = (array) => {
  hotspotArray = array;
};

export const setCurrentImage = (image) => {
  currentImage = image;
};

export const setInternalInterval = (newIntreval) => {
  interval = newIntreval;
};

export const clearInternalInterval = () => {
  if (interval) {
    clearInterval(interval);
    interval = null;
  }
};
export const stopAutorotation = () => {
  if (autoRotationInterval) {
    clearInterval(autoRotationInterval);
    autoRotationInterval = null;
  }
};
export const setAutorotation = (newAutoRotationInterval) => {
  autoRotationInterval = newAutoRotationInterval;
};

export const changeSrc = (src) => {
  currentImage = src;
  if (isSmothZoom) {
    if (image == null) image = document.querySelector("#image");
    document.querySelector("#image").src = getPath(src);
    addHostpots(src);
  } else {
    if (!isLoading) {
      frameLoaded(
        viewer.world.getItemAt(0),
        src.y * (xlength + 1) + src.x,
        src
      );
    }
  }
};

export const padNumber = (number) => {
  if (number > 9) return number;
  return "0" + number;
};

export const getPath = (coordinates) => {
  const x = padNumber(coordinates.x);
  const y = padNumber(coordinates.y);
  name = settings.photo_info.filename_prefix;
  name = name.replace("%row", x);
  name = name.replace("%axis", y);
  if (isSmothZoom) {
    return `assets/${name}.${settings.photo_info.filetype}`;
  } else {
    return `assets/${name}.js`;
  }
};
export const changeZoom = (isZoom) => {
  zoomMode = isZoom;
  if (isSmothZoom) {
    if (!isZoom) {
      image.style.transform = "scale(1)";
      const imageWidth = (((imgWidth / imgHeight) * window.innerHeight) / window.innerWidth * 100).toFixed(2);
      image.style.top = 0;
      image.style.left = (100 - imageWidth) / 2 + "%";
      addHostpots(currentImage);
    }
  }
  if (isZoom) {
    removeHostpots();
  } else {
    addHostpots(currentImage);
  }
};
export const setViewer = (newViewer, src) => {
  addHostpots(src);
  viewer = newViewer;
};

export const changeFullScreeenMode = () => {
  let fullScreenMode;
  if (
    !document.fullscreenElement &&
    !document.mozFullScreenElement &&
    !document.webkitFullscreenElement &&
    !document.msFullscreenElement
  ) {
    if (app.requestFullscreen) {
      fullScreenMode = true;
      app.requestFullscreen();
    } else if (app.mozRequestFullScreen) {
      fullScreenMode = true;
      app.mozRequestFullScreen();
    } else if (app.webkitRequestFullscreen) {
      fullScreenMode = true;
      app.webkitRequestFullscreen();
    } else if (app.msRequestFullscreen) {
      fullScreenMode = true;
      app.msRequestFullscreen();
    }
  } else {
    if (document.exitFullscreen) {
      fullScreenMode = false;
      document.exitFullscreen();
    } else if (document.msExitFullscreen) {
      fullScreenMode = false;
      document.msExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      fullScreenMode = false;
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      fullScreenMode = false;
      document.webkitExitFullscreen();
    }
  }
  stickWithRigthAspectRatio(fullScreenMode);
}

const frameLoaded = (oldTiledImage, index, src) => {
  isLoading = true;
  var tileSource = sourceArray[index];

  viewer.addTiledImage({
    tileSource: tileSource,
    index: 0,
    opacity: 1,
    preload: true,
    success: (event) => {
      var tiledImage = event.item;

      const ready = () => {
        viewer.world.removeItem(oldTiledImage);
        addHostpots(src);
        isLoading = false;
      };

      if (tiledImage.getFullyLoaded()) {
        ready();
      } else {
        tiledImage.addOnceHandler("fully-loaded-change", ready);
      }
    }
  });
};

const addHostpots = (src) => {
  if (!zoomMode) {
    const hotspots = hotspotArray.filter(
      (item) => item.name === `${src.x}${src.y}`
    );
    if (hotspots.length > 0) {
      hotspots.forEach((item) => {
        app.appendChild(item.el);
      });
    } else {
      removeHostpots();
    }
  }
};
const removeHostpots = () => {
  document.querySelectorAll(".hotspot").forEach((item) => item.remove());
};